export type ContractType = 'HRC20' | 'HRC721' | 'HRC1155' | 'MARKET';

export const ContractAddress: Record<ContractType, string> = {
  HRC20: '0x32dE25C7536e2eb9c2B49c64A0A292E2Ff8A7312',
  HRC721: '0xddd3200F23DF887E392726432EE76B4B64e18d50',
  HRC1155: '0xB1d0F494dbeb7e78c710E180f1c612fC9C7A5649',
  MARKET: '0x953fE7Bdb2b945cAAE59eB00870499e0Eae573fE',
};
